export default function ThoughtDots() {
  return (
    <div className='self-start mt-4 mb-6 ml-2 flex gap-1'>
      <span className='w-2 h-2 bg-red-600 rounded-full thought-dot thought-dot-1'></span>
      <span className='w-2 h-2 bg-red-600 rounded-full thought-dot thought-dot-2'></span>
      <span className='w-2 h-2 bg-red-600 rounded-full thought-dot thought-dot-3'></span>
    </div>
  );
}
